import { Box, useTheme } from '@mui/material';
import { memo } from 'react';
import { useCurrentTime } from '../hooks/useCurrentTime';

const getTopPercent = () => (new Date().getMinutes() / 60) * 100;

const BookingTimeLine = () => {
    const theme = useTheme();
    const topPercent = useCurrentTime({ getValue: getTopPercent });

    return (
        <Box
            sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                height: '1px',
                backgroundColor: theme.palette.primary.main,
                zIndex: 1,
                top: `${topPercent}%`,
                pointerEvents: 'none',
            }}
        />
    );
};

export default memo(BookingTimeLine);
